<a type="button" class="ion-float-left" size="small" style="text-decoration: none;" (click)="presentModal()"
  (keydown.enter)="presentModal()">
  <small translate>REGISTER.CREATE_USER</small>
</a>
